import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccountHelper from 'Workspace/helpers/AccountHelper';
import { Avatar } from '@pearsontechnology/aero-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  line-height: 1.2;

  & > *:first-child {
    flex-shrink: 0;
  }

  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;

function AccountSummary({ account }) {
  return (
    <Wrapper>
      <Avatar
        avatar={{
          ...account,
          avatarSmall: account.avatars[0] && `data:image/png;base64, ${account.avatars[0].data}`,
        }}
      />
      <span>{AccountHelper.getFullName(account)}</span>
    </Wrapper>
  );
}

AccountSummary.propTypes = {
  account: PropTypes.object,
};

export default AccountSummary;
